const GetSFTPGatewayLogs = 
  `query getSFTPGatewayLogs($count: Int, $cursor: String, $filterConfig: SFTPGatewayLogFilterConfigInput) {
    sftpGatewayLogs(first: $count, after: $cursor, filterConfig: $filterConfig) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          failed
          timestamp
          executionStartTime
          dataSource {
            id
          }
        }
      }
    }
  }
 `

const GetSFTPGatewayLog = `
  query getSFTPGatewayLog($id: String!) {
    sftpGatewayLog(id: $id) {
      id
      failed
      timestamp
      executionStartTime
      logURL
      businessLog {
        type
        timestamp
        message
      }
      dataSource {
        id
        name
        description
      }
    }
  }
`
module.exports = {
  GetSFTPGatewayLog,
  GetSFTPGatewayLogs
}